import { Fragment, useState } from "react";
import "../Dashboard/Dashboard.css";
import DemandPartner1 from "../Publisher/reporting/demandPartner1";
import { loggedInUserDetails } from "../utils/helper";
import Permission from "../security/permission";
import { AUTH_CODE } from "../security/authCodes";
import { useAuth } from "../security/authContext";
import { Alert } from "react-bootstrap";

const Dashboard = (data) => {
  const { hasPermission } = useAuth();
  const a = loggedInUserDetails();
  return (
    <Fragment>
      {hasPermission(AUTH_CODE.gamReporting.gamReport) ?
        <DemandPartner1 />
        : <Alert variant="success">No Dashboard Data</Alert>
      }
    </Fragment>
  );
}

export default Dashboard;
